import type React from 'react';

export type PageRouteType =
  | 'not-found'
  | 'home'
  | 'airports'
  | 'airport-detail'
  | 'blog'
  | 'blog-post'
  | 'flight-calculator'
  | 'currency-converter'
  | 'checklist'
  | 'game'
  | 'tools'
  | 'passenger-rights'
  | 'about'
  | 'contact'
  | 'privacy'
  | 'terms'
  | 'advertising'
  | 'editorial-policy'
  | 'quiz'
  | 'topic-hub';

export interface PageComponentProps {
  onNavigate?: (path: string) => void;
  airportId?: string;
  searchQuery?: string;
  slug?: string;
}

export type PageComponent = React.ComponentType<PageComponentProps>;

/**
 * Keep route pages out of the initial client bundle. The server and the
 * client both load the current route before rendering, so prerendered HTML
 * hydrates without a loading shell while subsequent routes remain split.
 */
export async function loadPageComponent(type: PageRouteType): Promise<PageComponent> {
  switch (type) {
    case 'not-found':
      return (await import('../pages/NotFoundPage')).default as PageComponent;
    case 'home':
      return (await import('../components/HomePage')).HomePage as unknown as PageComponent;
    case 'airports':
      return (await import('../pages/AirportsPage')).default as unknown as PageComponent;
    case 'airport-detail':
      return (await import('../pages/AirportDetailPage')).default as unknown as PageComponent;
    case 'blog':
      return (await import('../pages/BlogPage')).default as unknown as PageComponent;
    case 'blog-post':
      return (await import('../pages/BlogPostPage')).default as unknown as PageComponent;
    case 'flight-calculator':
      return (await import('../pages/FlightCalculatorPage')).default as unknown as PageComponent;
    case 'currency-converter':
      return (await import('../pages/CurrencyConverterPage')).default as unknown as PageComponent;
    case 'checklist':
      return (await import('../pages/ChecklistPage')).default as unknown as PageComponent;
    case 'game':
      return (await import('../pages/GamePage')).default as unknown as PageComponent;
    case 'tools':
      return (await import('../pages/ToolsPage')).default as unknown as PageComponent;
    case 'passenger-rights':
      return (await import('../pages/PassengerRightsPage')).default as unknown as PageComponent;
    case 'about':
      return (await import('../pages/AboutPage')).default as unknown as PageComponent;
    case 'contact':
      return (await import('../pages/ContactPage')).default as unknown as PageComponent;
    case 'privacy':
      return (await import('../pages/PrivacyPage')).default as unknown as PageComponent;
    case 'terms':
      return (await import('../pages/TermsPage')).default as unknown as PageComponent;
    case 'advertising':
      return (await import('../pages/AdvertisingPage')).default as unknown as PageComponent;
    case 'editorial-policy':
      return (await import('../pages/EditorialPolicyPage')).default as unknown as PageComponent;
    case 'quiz':
      return (await import('../pages/QuizPage')).default as unknown as PageComponent;
    case 'topic-hub':
      return (await import('../pages/TopicHubPage')).default as unknown as PageComponent;
  }
}
